import React from "react";
import { PaymentStatus } from "../../../redux/reducers";
import { utcDateAndTimeStringToLocalDate } from "../../../utils/dateFormat";
import { useTranslation } from "react-i18next";
import NumericFormat from "react-number-format";
import { moneyPrefix, moneySuffix } from "../../../utils/money";

interface ExpertPaymentHistoryItemProps {
  index: number;
  date: string;
  totalAmount: number;
  status: PaymentStatus;
}

const ExpertPaymentHistoryItem: React.FC<ExpertPaymentHistoryItemProps> = (props) => {
  const { totalAmount, index, date, status } = props;
  const { i18n } = useTranslation();

  return (
    <div className="summary-single">
      <div>
        <div className="title-area">
          <span className="no">{index + 1}</span>
          {utcDateAndTimeStringToLocalDate(date)}
        </div>
      </div>
      <h3 className={`${status === PaymentStatus.Paid ? `done` : ""}`}>
        <NumericFormat
          value={totalAmount}
          prefix={moneyPrefix(i18n.language)}
          suffix={moneySuffix(i18n.language)}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          displayType="text"
          renderText={(value) => <React.Fragment>{value}</React.Fragment>}
        />
      </h3>
    </div>
  );
};

export default ExpertPaymentHistoryItem;
